import { FormModal, InputField, useToast, noop } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { deleteProtocol } from '../../redux/actions';

export function ReasonForDeleteModal(props) {
  const { onClose = noop, onSuccess = noop, protocolId = undefined, visible = false } = props;

  // VARIABLES
  const defaultValues = {
    reason: undefined,
  };

  // HOOKS
  // Store
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.protocolReducer.protocolAction);
  // Custom
  const { showErrorToast, showSuccessToast } = useToast();

  const fields = [
    new InputField({
      disabled: loading,
      id: 'reason',
      label: `Reason for Deleting`,
      maxLength: 250,
      required: true,
      value: defaultValues.reason,
    }),
  ];

  const onCreate = (data) => {
    dispatch(
      deleteProtocol({
        identifier: protocolId,
        onError: showErrorToast,
        onSuccess: () => {
          showSuccessToast('Trial Configuration deleted successfully');
          onSuccess();
        },
        reasonForDeleting: data?.reason,
      }),
    );
  };

  return (
    <FormModal
      defaultValues={defaultValues}
      fields={fields}
      loading={loading}
      onClose={onClose}
      onCreate={onCreate}
      title="Deleting Trial Configuration"
      visible={visible}
    />
  );
}

ReasonForDeleteModal.propTypes = {
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  protocolId: PropTypes.number,
  visible: PropTypes.bool,
};

export default ReasonForDeleteModal;
